module.exports = __webpack_public_path__ + "static/ilustracao-indicadores-desempenho-e9163459368de7fe2d2abb5658ece2a1.svg";